import Module from "layout/Module";
import useAZZKUTopData from "hooks/AZZKU/useAZZKUTopData";
import useAZZKULatestEdition from "hooks/AZZKU/useAZZKULatestEdition";

import StepsBox from "components/StepsBox";
import Step1 from "./steps/Step1";
import Step2 from "./steps/Step2";
import Step3 from "./steps/Step3";
import AZZKUTopResultsSidebar from "./components/AZZKUTopResultsSidebar";
import AZZKUTopResultsMain from "./components/AZZKUTopResultsMain";

export default function AZZKUTopModule() {
   const { d: editionData } = useAZZKULatestEdition();

   return (
      <Module
         results_props={{
            init_mode: "table",
            dataHook: useAZZKUTopData,
            SidebarComponent: AZZKUTopResultsSidebar,
            MainComponent: AZZKUTopResultsMain           
         }}

         Component={( props ) => (
            <>
               <h2> Wybierz zakres danych </h2>

               <p> Wybierz dane oraz filtry, na podstawie których chcesz wygenerować ranking. </p>

               <StepsBox
                  {...props }
                  editionData={editionData}
                  steps={[
                     {
                        title: "Krok 1: Wybór danych",
                        next_btn: "Przejdź do wyboru roku",
                        validation_fields: [{
                           name: "topics",
                           fn: data => !!data.topics && !!data.topics?.length,
                           message: "Proszę wybrać temat"
                        }, {
                           name: "variable_id",
                           message: "Proszę wybrać wskaźnik"
                        }],
                        Content: Step1 
                     },
                     {
                        title: "Krok 2: Wybór roku",
                        prev_btn: "Wróć do wyboru danych",
                        next_btn: "Przejdź do wyboru obszaru",
                        validation_fields: [
                           { name: "year" }
                        ],
                        Content: Step2
                     },
                     {
                        title: "Krok 3: Wybór obszaru",
                        prev_btn: "Wróć do wyboru roku",
                        next_btn: "Generuj wyniki",
                        validation_fields: [{
                           name: "voivodeship_ids",
                           fn: data => Array.isArray( data.voivodeship_ids ) && !!data.voivodeship_ids?.length
                        }],
                        Content: Step3
                     }
                  ]}
               />
            </>
         )}
      />
   )
}